var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      cursor: "pointer"
    },
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".leaderboard-cls-1{fill:url(#leaderboard-linear-gradient);}.leaderboard-cls-2{fill:#e31f26;}.leaderboard-cls-3{fill:#fffcd5;}.leaderboard-cls-4{fill:url(#leaderboard-linear-gradient-2);}")), /*#__PURE__*/React.createElement("linearGradient", {
    style: {
      cursor: "pointer"
    },
    id: "leaderboard-linear-gradient",
    x1: 96.53,
    y1: 183.17,
    x2: 96.53,
    y2: 13.63,
    gradientTransform: "translate(97.85 -39.44) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.31,
    stopColor: "#f5da52"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 1,
    stopColor: "#fff799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    style: {
      cursor: "pointer"
    },
    id: "leaderboard-linear-gradient-2",
    x1: 96.53,
    y1: 135.97,
    x2: 96.53,
    y2: 60.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0,
    stopColor: "#e31f26"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 1,
    stopColor: "#fff450"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      cursor: "pointer"
    },
    className: "leaderboard-cls-1",
    cx: 96.53,
    cy: 98.4,
    r: 84.77,
    transform: "translate(-41.31 97.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      cursor: "pointer"
    },
    className: "leaderboard-cls-2",
    d: "M96.53,13.63A84.77,84.77,0,1,1,11.76,98.4,84.77,84.77,0,0,1,96.53,13.63m0-5.23A90,90,0,0,0,32.89,162,90,90,0,1,0,131.56,15.48a89.33,89.33,0,0,0-35-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      cursor: "pointer"
    },
    className: "leaderboard-cls-3",
    d: "M96.53,19.41a84.76,84.76,0,0,1,84.7,81.88c0-1,.07-1.92.07-2.89a84.77,84.77,0,0,0-169.54,0c0,1,0,1.93.07,2.89A84.76,84.76,0,0,1,96.53,19.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      cursor: "pointer"
    },
    className: "leaderboard-cls-3",
    cx: 96.53,
    cy: 98.4,
    r: 69.87
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      cursor: "pointer"
    },
    className: "leaderboard-cls-4",
    d: "M140.7,78.52a18.72,18.72,0,0,0-7.56-13.19,24,24,0,0,0-8.46-3.74A8,8,0,0,0,117,55.86H76a8,8,0,0,0-7.66,5.73,24,24,0,0,0-8.46,3.74,18.72,18.72,0,0,0-7.56,13.19C51.19,89,59.65,97.39,68.72,100.94a38.21,38.21,0,0,0,5.92,1.73,28.57,28.57,0,0,0,13.35,9v17h-5.9a6.39,6.39,0,0,0-6.46,5.52,6.14,6.14,0,0,0,6.11,6.78H111a6.38,6.38,0,0,0,6.46-5.52,6.14,6.14,0,0,0-6.11-6.78h-6.25v-17a28.57,28.57,0,0,0,13.35-9,38.21,38.21,0,0,0,5.92-1.73C133.41,97.39,141.87,89,140.7,78.52ZM60.87,84.7a10.86,10.86,0,0,1,1.62-11.46A12.78,12.78,0,0,1,68,69.66V84.39a28.47,28.47,0,0,0,1.31,8.51A16.59,16.59,0,0,1,60.87,84.7Zm71.32,0a16.63,16.63,0,0,1-8.44,8.2,28.47,28.47,0,0,0,1.31-8.51V69.66a12.78,12.78,0,0,1,5.51,3.58A10.86,10.86,0,0,1,132.19,84.7Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.839c7153.svg";
export { ForwardRef as ReactComponent };